import variables from "../styles/element-variables.scss";
import defaultSettings from '@/settings';
var showSettings = defaultSettings.showSettings,
  tagsView = defaultSettings.tagsView,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo;
var state = {
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, data) {
    if (state.hasOwnProperty(data.theme)) {
      state[data.theme] = data.val;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref, data) {
    var commit = _ref.commit;
    commit('CHANGE_SETTING', data);
  }
};
export default {
  state: state,
  mutations: mutations,
  actions: actions
};